import { CheckmarkIconFilled, CloseIconFilled, MinusIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { Button, HorizontalSeparator, ParagraphWithTooltip, fontWeights } from '@va/ui/design-system';
import { TooltipWrapper } from '@va/ui/tooltips';
import Skeleton from 'react-loading-skeleton';
import { EmailItem } from '../apiClient';

type EmailListItemsProps = {
  listItems: EmailItem[];
  infoTooltip?: string;
  disabled?: boolean;
  isLoading: boolean;
  onRemoveClick?: (email: string) => void;
  onResendEmailConfirmation?: (email: string) => void;
};

export const EmailListItems = ({
  listItems,
  infoTooltip,
  disabled,
  isLoading,
  onRemoveClick,
  onResendEmailConfirmation,
}: EmailListItemsProps) => {
  const translate = useTranslate();

  if (isLoading) {
    return (
      <div className={'flex flex-col'}>
        {Array.from(Array(2).keys()).map((_, index) => (
          <Skeleton className='h-72 rounded-18' key={index} />
        ))}
      </div>
    );
  }
  return (
    <div className='flex flex-col gap-3 w-full not:empty:p-2'>
      {!!listItems.length && <HorizontalSeparator className='h-0.5 -mx-2! to-white-snow!' />}
      {listItems.map(({ value, verified }, index) => {
        return (
          <li className='flex items-center gap-2 justify-between p-2 bg-white rounded-15 h-16' key={index}>
            <div className='grow overflow-hidden'>
              <ParagraphWithTooltip className='truncate' weight={fontWeights.medium}>
                {value}
              </ParagraphWithTooltip>
            </div>
            {verified && (
              <TooltipWrapper content={translate('generalSettings.emailReports.acceptedTooltip')}>
                <span>
                  <CheckmarkIconFilled />
                </span>
              </TooltipWrapper>
            )}
            {!verified && (
              <TooltipWrapper content={translate('generalSettings.emailReports.notAcceptedTooltip')}>
                <span>
                  <CloseIconFilled />
                </span>
              </TooltipWrapper>
            )}
            {!verified && (
              <Button
                color='tertiary'
                text={translate('button.resendVerificationMail')}
                onClick={() => {
                  onResendEmailConfirmation?.(value);
                }}
              />
            )}
            <Button
              color='tertiary'
              icon={() => <MinusIcon />}
              onClick={() => {
                onRemoveClick?.(value);
              }}
              tooltip={infoTooltip}
              disabled={disabled}
              className='shrink-0 bg-white-snow rounded-12 w-12 h-12 flex items-center justify-center hover:bg-gray-concrete transition-all duration-200'
            />
          </li>
        );
      })}
    </div>
  );
};
